import React, { useState } from 'react'
import {
  Alert,
  Card,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  FormSelect,
  Modal,
  Button,
} from 'react-bootstrap'
import { t } from '../locale'
import KButton from './KButton'

interface PrivacyPolicyModalProps {
  show: boolean
  onClose: () => void
  onAccept: () => void
  onDelete?: () => void
  existingIdentity?: {
    identityCompanyId?: string
    identityRequestId?: string
    status?: string
    createdAt?: string
  }
}

const IdentityModal: React.FC<PrivacyPolicyModalProps> = ({
  show,
  onClose,
  onAccept,
  onDelete,
  existingIdentity,
}) => {
  const [gender, setGender] = useState(localStorage.getItem('gender') ?? '')
  const [firstName, setFirstName] = useState(localStorage.getItem('firstName') ?? '')
  const [lastName, setLastName] = useState(localStorage.getItem('name') ?? '')
  const [email, setEmail] = useState(localStorage.getItem('clientEmail') ?? '')
  const [dateOfBirth, setDateOfBirth] = useState(localStorage.getItem('dateOfBirth') ?? '')

  function handleGender(e: any) {
    setGender(e.target.value)
    localStorage.setItem('gender', e.target.value)
  }
  function handleEmail(e: any) {
    setEmail(e.target.value)
    localStorage.setItem('clientEmail', e.target.value)
  }
  function handleDateOfBirth(e: any) {
    setDateOfBirth(e.target.value)
    localStorage.setItem('dateOfBirth', e.target.value)
  }
  function handleLastName(e: any) {
    setLastName(e.target.value)
    localStorage.setItem('name', e.target.value)
  }
  function handleFirstName(e: any) {
    setFirstName(e.target.value)
    localStorage.setItem('firstName', e.target.value)
  }

  return (
    <Modal show={show} onHide={onClose} centered dialogClassName='modal-xl modern-modal'>
      <Modal.Header closeButton>
        <Modal.Title className='modal-title'>
          {t('Anfrage für Videoidentifikation über DS|Identity')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='modal-body-content'>
          {existingIdentity && !!onDelete && (
            <>
              <Alert variant='warning' className='mb-3'>
                <div className='fw-semibold mb-2'>{t('Existing DS|Identity request')}</div>
                <div>
                  {t('Status')}: {existingIdentity.status || '-'}
                </div>
              </Alert>
              <KButton
                size='sm'
                title={t('Remove existing DS|Identity request')}
                label={t('Remove DS|Identity request')}
                variant='danger'
                onClick={onDelete}
                className='mb-3'
              />
            </>
          )}

          <Card>
            <Card.Body>
              <Form>
                <FormGroup>
                  <FormLabel htmlFor='gender'>{t('gender')}</FormLabel>
                  <FormSelect
                    id='gender'
                    isInvalid={false}
                    value={gender}
                    onChange={handleGender}
                    className='w-25'
                  >
                    <option value=''>--</option>
                    <option value='M'>{t('M')}</option>
                    <option value='F'>{t('F')}</option>
                    <option value='other'>{t('other')}</option>
                  </FormSelect>
                </FormGroup>

                <FormGroup className='mt-3'>
                  <FormLabel htmlFor='lastName'>{t('lastName')}</FormLabel>
                  <FormControl
                    id='lastName'
                    isInvalid={false}
                    placeholder={t('lastName')}
                    value={lastName}
                    onChange={handleLastName}
                    autoComplete='off'
                  />
                </FormGroup>

                <FormGroup className='mt-3'>
                  <FormLabel htmlFor='firstName'>{t('firstName')}</FormLabel>
                  <FormControl
                    id='firstName'
                    isInvalid={false}
                    placeholder={t('firstName')}
                    value={firstName}
                    onChange={handleFirstName}
                    autoComplete='off'
                  />
                </FormGroup>

                <FormGroup className='mt-3'>
                  <FormLabel htmlFor='dateOfBirth'>{t('dateOfBirth')}</FormLabel>
                  <FormControl
                    id='dateOfBirth'
                    isInvalid={false}
                    placeholder={t('dateOfBirth')}
                    value={dateOfBirth}
                    onChange={handleDateOfBirth}
                    autoComplete='off'
                  />
                </FormGroup>

                <FormGroup className='mt-3'>
                  <FormLabel htmlFor='email'>{t('email')}</FormLabel>
                  <FormControl
                    id='email'
                    isInvalid={false}
                    placeholder={t('email')}
                    value={email}
                    onChange={handleEmail}
                    autoComplete='off'
                  />
                </FormGroup>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='primary'
          onClick={onAccept}
          // disabled={!isChecked}
          className='accept-button'
          disabled={!!existingIdentity}
        >
          {t('confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default IdentityModal
